// Add outputs with id, title, year (or date), authors, description, and url or pdfUrl.
// Available year filters are generated from these records.
const OtherOutputsData = {
  posters: [],
  presentations: [],
};
export default OtherOutputsData;
